export default __webpack_public_path__ + "static/media/shape-triangle.db0cc738.PNG";